import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Transfer, TransferActionRequest, TransferRequest } from '../interfaces/treasury.interface';

const E = ENDPOINTS.BANK_TRANSFER;
export type TransferAction = 'approve' | 'reject' | 'cancel' | 'send' | 'receive' | 'send-and-receive';

export const BankTransferService = {
  list: async (institutionId: string, status?: string): Promise<Transfer[]> =>
    (await axios.get(E.LIST(institutionId), { params: status ? { status } : {} })).data,
  get: async (id: string): Promise<Transfer> => (await axios.get(E.ONE(id))).data,
  create: async (body: TransferRequest): Promise<Transfer> => (await axios.post(E.BASE, body)).data,
  act: async (id: string, action: TransferAction, body?: TransferActionRequest): Promise<Transfer> =>
    (await axios.post(E.ACTION(id, action), body ?? {})).data,
  approve: async (id: string): Promise<Transfer> => (await axios.post(E.ACTION(id, 'approve'))).data,
  reject: async (id: string, notes: string): Promise<Transfer> => (await axios.post(E.ACTION(id, 'reject'), { notes })).data,
  cancel: async (id: string, notes?: string): Promise<Transfer> => (await axios.post(E.ACTION(id, 'cancel'), { notes })).data,
  send: async (id: string, date?: string): Promise<Transfer> => (await axios.post(E.ACTION(id, 'send'), { date })).data,
  receive: async (id: string, date?: string): Promise<Transfer> => (await axios.post(E.ACTION(id, 'receive'), { date })).data,
  sendAndReceive: async (id: string, date?: string): Promise<Transfer> =>
    (await axios.post(E.ACTION(id, 'send-and-receive'), { date })).data,
};
